var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generate-test-paper-setting"},[_c('setting-exam-time-and-exam-pass-score'),(_vm.showAddExamObject)?_c('add-exam-object',{attrs:{"exam-id":_vm.examId}}):_vm._e(),_c('selected-exam-object')],1)}
var staticRenderFns = []

export { render, staticRenderFns }